import { render } from "./CustomerService.vue?vue&type=template&id=4c59be0c"
import script from "./CustomerService.vue?vue&type=script&lang=js"
export * from "./CustomerService.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/AirCNavBar/icons/CustomerService.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4c59be0c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4c59be0c', __exports__)) {
    api.reload('4c59be0c', __exports__)
  }
  
  module.hot.accept("./CustomerService.vue?vue&type=template&id=4c59be0c", () => {
    api.rerender('4c59be0c', render)
  })

}


export default __exports__